import { Component, Inject, OnInit, AfterViewInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { DOCUMENT } from '@angular/common'

import { environment } from '../../environments/environment'
import { TrackingService } from '../services/tracking.service'

/**
 * Tiny Component
 *
 * @author Jesús Fernández
 *
 * Used for shortened urls that backend redirects.
 */
@Component({
  selector: 'app-tiny',
  templateUrl: './tiny.component.html',
  styleUrls: []
})
export class TinyComponent implements OnInit, AfterViewInit {
  /**
   * Route parameter pyf/:tinyurl
   */
  private tiny: string

  /**
   * @ignore
   */
  constructor(
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private _document,
    private trackingService: TrackingService,
    private router: Router
  ) {
    this.route.params.subscribe((params) => {
      this.tiny = params['tinyurl']
    })
  }

  /**
   * On init component, it is redirected to the route returned by the backend route shortener.
   */
  ngOnInit() {
    const URL_API_TINY = environment.URL_API_TINY
    location.href = URL_API_TINY + `${this.tiny}`
    this._document.location.href = URL_API_TINY + `${this.tiny}`
  }

  /**
   * Captures access sms event and sends event data.
   */
  smsEvent() {
    this.trackingService.setHash(this.tiny)
    this.trackingService.smsEvent()
  }

  ngAfterViewInit(): void {
    this.smsEvent()
  }
}
